import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import LandingPage from './pages/customer/LandingPage';
import ShopsListPage from './pages/customer/ShopsListPage';
import ShopDetailPage from './pages/customer/ShopDetailPage';
import MyBookings from './pages/customer/MyBookings';
import ShopReports from './pages/barber/ShopReports';
import LoginPage from './pages/LoginPage';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminShops from './pages/admin/AdminShops';
import AdminShopDetail from './pages/admin/AdminShopDetail';
import AdminPlans from './pages/admin/AdminPlans';
import AdminAddShop from './pages/admin/AdminAddShop';

// Shop Pages
import ShopDashboard from './pages/barber/ShopDashboard';
import ShopBookings from './pages/barber/ShopBookings';
import ShopServices from './pages/barber/ShopServices';
import ShopStaff from './pages/barber/ShopStaff';
import ShopProfile from './pages/barber/ShopProfile';
import ShopHours from './pages/barber/ShopHours';
import SubscriptionExpired from './pages/barber/SubscriptionExpired';

const PrivateRoute = ({ children, role }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"/></div>;
  if (!user) return <Navigate to="/login" />;
  if (role && user.role !== role) return <Navigate to="/" />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/shops" element={<ShopsListPage />} />
      <Route path="/shop/:slug" element={<ShopDetailPage />} />
      <Route path="/my-bookings" element={<MyBookings />} />
      <Route path="/dashboard/reports" element={<ShopReports />} />
      <Route path="/login" element={<LoginPage />} />

      {/* Master Admin */}
      <Route path="/admin" element={<PrivateRoute role="admin"><AdminDashboard /></PrivateRoute>} />
      <Route path="/admin/shops" element={<PrivateRoute role="admin"><AdminShops /></PrivateRoute>} />
      <Route path="/admin/shops/add" element={<PrivateRoute role="admin"><AdminAddShop /></PrivateRoute>} />
      <Route path="/admin/shops/:id" element={<PrivateRoute role="admin"><AdminShopDetail /></PrivateRoute>} />
      <Route path="/admin/plans" element={<PrivateRoute role="admin"><AdminPlans /></PrivateRoute>} />

      {/* Shop Panel */}
      <Route path="/dashboard" element={<PrivateRoute role="shop"><ShopDashboard /></PrivateRoute>} />
      <Route path="/dashboard/bookings" element={<PrivateRoute role="shop"><ShopBookings /></PrivateRoute>} />
      <Route path="/dashboard/services" element={<PrivateRoute role="shop"><ShopServices /></PrivateRoute>} />
      <Route path="/dashboard/staff" element={<PrivateRoute role="shop"><ShopStaff /></PrivateRoute>} />
      <Route path="/dashboard/profile" element={<PrivateRoute role="shop"><ShopProfile /></PrivateRoute>} />
      <Route path="/dashboard/hours" element={<PrivateRoute role="shop"><ShopHours /></PrivateRoute>} />
      <Route path="/subscription-expired" element={<SubscriptionExpired />} />
    </Routes>
  );
}

export default function App() {
  useEffect(() => {
    const host = window.location.hostname;
    document.title = host.startsWith('parlour') ? 'ParlourHub Pakistan' : host.startsWith('dentist') ? 'DentistHub19 Pakistan' : 'BarberHub Pakistan';
  }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
